module.exports = __webpack_public_path__ + "img/x-circle-white.57367e97.svg";